import Layout from '@/layouts/BasicLayout/index.vue'
import type { RouteRecordRaw } from 'vue-router'

const indexPage: RouteRecordRaw = {
  path: '/index',
  name: 'IndexPage',
  component: Layout,
  meta: {
    title: '首页',
    module: 'INDEX_PAGE',
    icon: 'icon-index-page|svg'
  },
  children: [
    {
      path: '',
      name: 'IndexPageMain',
      component: () => import('@/views/IndexPage/index.vue'),
      meta: {
        title: '首页',
        module: 'INDEX_PAGE'
      }
    }
  ]
}

export default indexPage
